import Vue from 'vue'
import Vuex from 'vuex'
import error from './modules/error'
import layout from './modules/layout'
import locale from './modules/locale'
import menu from './modules/menu'
import sys from './modules/sys'
import theme from './modules/theme'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    error,
    layout,
    locale,
    menu,
    sys,
    theme
  }
})
